import * as Yup from "yup";
import { UserOperationLog } from "../../../entity/UserOperationLog";

/***************************************************************
 * ユーザー新規追加
 **************************************************************/
/**
 * エラーメッセージ
 */
export const ERR_MESSAGE = {
  idIsNull: "ユーザーIDを入力してください。",
  fullNameIsNull: "氏名を入力してください。",
  emailIsNull: "メールアドレスを入力してください",
  passwordIsNull: "パスワードを入力してください",
  passwordAgainIsNull: "パスワード(確認)を入力してください",
  roleCdIsNull: "権限を選択してください。",
  lockStatusIsNull: "ステータスを選択してください。",
  isMfaauthIsNull: "MFA認証を選択してください。",
  check: "チェックしてください。",
};

/**
 * バリデーションルール
 */
export const MdmUserCreateFormSchema = Yup.object({
  fullName: Yup.string().required(ERR_MESSAGE.fullNameIsNull),
  email: Yup.string().required(ERR_MESSAGE.emailIsNull),
  password: Yup.string().required(ERR_MESSAGE.passwordIsNull),
  passwordAgain: Yup.string().required(ERR_MESSAGE.passwordAgainIsNull),
  lockStatus: Yup.string().required(ERR_MESSAGE.lockStatusIsNull),
  roleCd: Yup.string().required(ERR_MESSAGE.roleCdIsNull),
  isMfaauth: Yup.string().required(ERR_MESSAGE.isMfaauthIsNull),
});
export const MdmUserEditFormSchema = Yup.object({
  fullName: Yup.string().required(ERR_MESSAGE.fullNameIsNull),
  email: Yup.string().required(ERR_MESSAGE.emailIsNull),
  lockStatus: Yup.string().required(ERR_MESSAGE.lockStatusIsNull),
  roleCd: Yup.string().required(ERR_MESSAGE.roleCdIsNull),
  isMfaauth: Yup.string().required(ERR_MESSAGE.isMfaauthIsNull),
});
/**
 * ユーザー新規作成・編集フォーム(入力チェック用)
 */
export class MdmUserEditForm {
  /** ユーザーID */
  public userId: string = "";
  /** 氏名 */
  public fullName: string = "";
  /** メールアドレス */
  public email: string = "";
  /** パスワード */
  public password: string = "";
  /** パスワード(確認用) */
  public passwordAgain: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** 企業名 */
  public tenantName: string = "";
  /** 組織ID */
  public orgId: string = "";
  /** 組織名 */
  public organizationName: string = "";
  /** ユーザーレベル */
  public userLevel: string = "";
  /** テナント都合によるロック */
  public tenantLock = "";
  /** ロールCD */
  public roleCd: string = "";
  /** ロックステータス */
  public lockStatus: string = "";
  /** アクセス権限 */
  public accessAuth: number = 0;
  /** アカウント有効期限 */
  public expireDate: string = "";
  /** アカウント有効期限（表示用） */
  public expireDateView: Date | null = null;
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
  /** MFA認証 */
  public isMfaauth: string = "";
  /** コメント */
  public comment: string = "";
}
// 新規追加用 リクエスト
export class MdmUserCreateRequest {
  createdata: MdmUserEditForm = new MdmUserEditForm();
}
// 編集用 リクエスト
export class MdmUserEditRequest {
  editdata: MdmUserEditForm = new MdmUserEditForm();
}

/***************************************************************
 * ユーザー詳細
 **************************************************************/
/**
 * ユーザー詳細取得API リクエスト
 */
export class MdmUserDetailRequest {
  /** ユーザーID */
  public id: string = "";
}

/**
 * ユーザー詳細取得API レスポンス
 */
export class MdmUserDetailResponse {
  /** ユーザーID */
  public id: string = "";
  /** 氏名 */
  public fullName: string = "";
  /** メールアドレス */
  public email: string = "";
  /** パスワード */
  public password: string = "";
  /** パスワード(確認用) */
  public passwordAgain: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** 企業名 */
  public tenantName: string = "";
  /** 組織ID */
  public organizationId: string = "";
  /** 組織名 */
  public organizationName: string = "";
  /** ユーザーレベル */
  public userLevel = "";
  /** テナント都合によるロック */
  public tenantLock = "";
  /** ロックステータス */
  public lockStatus = "";
  /** ロック日時 */
  public lockDate: string = "";
  /** アカウント有効期限 */
  public expireDate: string = "";
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
  /** 最終ログイン日時 */
  public lastloginDate: string = "";
  /** MFA認証 */
  public isMfaauth: string = "";
  /** コメント */
  public comment: string = "";
  /** 操作ログ */
  public userOperationLog: UserOperationLog[] = [];
}

/***************************************************************
 * 他箇所との連携用
 **************************************************************/
/**
 * テナント情報（ID、会社名）取得API リクエスト
 */
export class MdmUserNameRequest {
  /** テナントID */
  public id: string = "";
}
/**
 * テナント情報（ID、会社名）取得API レスポンス
 */
export class MdmUserNameResponse {
  /** テナントID */
  public id: string = "";
  /** 会社名 */
  public userName: string = "";

  public email: string = "";
}

/***************************************************************
 * ユーザー一覧
 **************************************************************/
/**
 * ユーザー情報一覧取得API リクエスト
 */
export class MdmUserSearchRequest {
  /** テナント名 */
  public tenantName: string = "";
  /** 氏名 */
  public fullName: string = "";
  /** メールアドレス */
  public email: string = "";
}

/**
 * ユーザー情報一覧取得API レスポンス
 */
export class MdmUserSearchResponse {
  /** ユーザーID */
  public id: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 氏名 */
  public fullName: string = "";
  /** メールアドレス */
  public email: string = "";
  /** アクセス権限 */
  public accessAuth: number = 0;
  /** MFA認証 */
  public isMfaauth: boolean = false;
  /** テナント都合によるロック */
  public tenantLock: boolean = false;
  /** アカウント有効期限 */
  public expireDate: string = "";
  /** 最終ログイン日時 */
  public lastloginDate: string = "";
  /** タグ */
  public tag: any[] = [];
  /** ロール名 */
  public roleName: string = "";
  /** ロックステータス */
  public lockStatus: string = "";
  /** ダミー */
  public dummy: string = "";
  /** DT_RowId */
  public DT_RowId: any = null;
}
